<div
  class="platform-switcher position-relative"
  ref="switcher"
>
  <button
    class="platform-switcher-toggle nav-link p-0"
    type="button"
    :aria-label="`Open ${primary_platform?.label || 'BCX Data'}`"
    :aria-busy="is_switching ? 'true' : 'false'"
    :title="primary_platform?.label || 'BCX Data'"
    :disabled="!primary_platform || primary_platform.disabled || is_switching"
    @click="switch_to_primary_platform"
  >
    <span v-if="is_switching" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
    <i v-else class="bi bi-window-stack fs-6"></i>
  </button>

  <p v-if="error_message" class="platform-switcher-error text-danger small position-absolute top-100 end-0 mt-1 mb-0 text-nowrap">
    {{ error_message }}
  </p>
</div>
